// extracted by mini-css-extract-plugin
module.exports = {"verified":"AV8CMDgZvK2H6CLbF706"};